// extracted by mini-css-extract-plugin
var _1 = "Core_message__H+b3+";
var _2 = "Core_messageContent__tLqvR";
var _3 = "Core_messageHeader__Rrg1b";
export { _1 as "message", _2 as "messageContent", _3 as "messageHeader" }
